export const constants = {
  pageName: {
    simulator: 'Dados para Simular',
    simulationResult: 'Resultado da simulação',
    ownerData: 'Dados do tomador',
    additionalRiskData: 'Dados Adicionais de Risco',
    summaryConditions: 'Resumo das Condições',
    formalization: 'Formalização',
    confirmation: 'Confirmação',
  },
  priceType: {
    ANN: 'Ano',
    BNN: 'Semestre',
    QTL: 'Trimestre',
    MTL: 'Mês',
  },
  questionCode: {
    MOR: 'MOR',
    BES: 'BES',
    VAC: 'VAC',
    INC: 'INC',
    PAC: 'PAC',
    RPP: 'RPP',
    DCE: 'DCE',
    TSA: 'TSA',
    PDT: 'PDT',
    PM: 'PM',
  },
  referrals: {
    warning: 'W',
    fullStop: 'S',
    manualAction: 'M',
  },
  routes: {
    base: '/',
    simulationResult: '/resultado-da-simulacao',
    ownerData: '/dados-do-tomador',
    additionalRiskData: '/dados-adicionais-de-risco',
    summaryConditions: '/resumo-das-condicoes',
    formalization: '/formalizacao',
    confirmation: '/confirmacao',
  },
  phoneTypes: {
    fax: 'Fax',
    otherPhone: 'Outro Telefone p/ Contacto',
    landline: 'Telefone Fixo',
    phone: 'Telemóvel',
  },
}
